<template>
  <div>
    <popup
      class="popup-info"
      width="360px"
      height="522px"
      @close="close"
      v-if="showdhtx"
    >
      <div class="dhtx-box c-pointer">
        <div class="dh" @click="topage()">
          <div class="dh-btn c-pointer"></div>
        </div>
        <div class="title hdx">
          <img :src="require('@/assets/images/hdx.png')" @click="close" />
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showdhtx: false,
    };
  },
  methods: {
    close() {
      this.showdhtx = false;
    },
    topage() {
      this.$router.push({ name: "smActivityList" });
    },
  },
};
</script>
<style lang='scss' scoped>
.popup-info {
  position: relative;
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    margin-top: 60px;
    text-align: center;
    margin-bottom: 20px;
    padding: 0px 30px;
    line-height: 23px;
  }
  .btn {
    text-align: center;
    span {
      @include btn(124px, 44px, #fa4b4b, #ffffff, 16px, 2px);
    }
    .span2 {
      border: 1px solid #fa4b4b;
      color: #fa4b4b;
      background: none;
      margin-left: 20px;
    }
  }
  .close {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
.dhtx-box {
  @include flex-d-c;
  .dh {
    width: 360px;
    height: 522px;
    background: url("../../assets/images/d_smtj.png") no-repeat;
    background-size: 100%;
    position: relative;
  }
}

.hdx {
  width: 100%;
  position: absolute;
  bottom: -94px;
}
.popup-container .modal {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/plugins/smActivity.vue